import ExcelJS from "exceljs";
import { formatDateTimeWithoutSec } from "../../Common/helper/helpar";
import usetransferstationCategoryStore from "./store/transferstationCategoryStore";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import ExportMenu from "../../Common/ExportMenu/ExportMenu";
export const ExportTransferstationCategoryData = () => {
  const { transferstationCategory } = usetransferstationCategoryStore();

  const downloadExcel = async () => {
    const { FromDateTime, ToDateTime } = JSON.parse(localStorage.getItem("sat-trips-zone-filters")) || {};

    // Get current date/time for header
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const filterDateRange =
      FromDateTime && ToDateTime ? `(${formatDateTimeWithoutSec(FromDateTime)} to ${formatDateTimeWithoutSec(ToDateTime)})` : "";

    const reportTitle = `Transferstation Feedback Category`;
    const generatedText = `Report Generated on: ${formattedDate}, ${formattedTime}`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zone");

    const boldFont = { bold: true };
    const centerAlignment = { horizontal: "center", vertical: "middle", wrapText: true };

    // --- Header Row 1: Report Title ---
    const headerRow1 = worksheet.addRow([generatedText]);
    worksheet.mergeCells(headerRow1.number, 1, headerRow1.number, 3);
    headerRow1.getCell(1).font = boldFont;
    headerRow1.getCell(1).alignment = centerAlignment;

    // --- Header Row 2: Generated Date/Time ---
    const headerRow2 = worksheet.addRow([reportTitle]);
    worksheet.mergeCells(headerRow2.number, 1, headerRow2.number, 3);
    headerRow2.getCell(1).font = boldFont;
    headerRow2.getCell(1).alignment = centerAlignment;

    // --- Table Header Row ---
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Feedback Name",
      "Feedback Rating",
      "Status",
    ]);
    tableHeaderRow.eachCell((cell) => {
      cell.font = boldFont;
      cell.alignment = centerAlignment;
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "F6B1B1" },
      };
    });

    // --- Data Rows ---
    let totalFeedbackRating = 0;
    transferstationCategory.forEach((item, index) => {
      if (item.isActive) {
        totalFeedbackRating += item.feedBackRating; // Only add active feedback ratings
      }

      const row = worksheet.addRow([
        index + 1,
        item.feedBackName,
        item.feedBackRating,
        item.isActive ? "Active" : "InActive",
      ]);
      row.eachCell((cell) => {
        cell.alignment = centerAlignment;
      });
    });

    // --- Total Feedback Rating Row ---
    const totalRow = worksheet.addRow([
      "", // Empty for S.No
      "Total", // Label under "Feedback Name"
      totalFeedbackRating, // Total value under "Feedback Rating"
      "", // Empty for Status
    ]);
    totalRow.eachCell((cell, colNumber) => {
      if (colNumber === 2 || colNumber === 3) {
        cell.font = boldFont;
        cell.alignment = centerAlignment;
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "D3D3D3" }, // Light gray background
        };
      }
    });

    // --- Adjust Column Widths ---
    worksheet.columns = [
      { width: 10 },
      { width: 20 },
      { width: 25 },
      { width: 25 },
    ];

    // --- Save and Download Workbook ---
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "TransferStationCategory.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };




  // Export as PDF
  const downloadPDF = () => {
    const doc = new jsPDF();

    // Centered Title
    doc.text("Transfer Station Feedback Category", doc.internal.pageSize.getWidth() / 2, 10, { align: "center" });

    // Calculate Total Feedback Rating
    let totalFeedbackRating = 0;
    transferstationCategory.forEach((row) => {
      if (row.isActive) {
        totalFeedbackRating += row.feedBackRating || 0;
      }
    });

    // Prepare Table Data
    const tableData = transferstationCategory.map((row, index) => [
      { content: index + 1, styles: { halign: "center" } },
      { content: row.feedBackName || "N/A", styles: { halign: "center" } },
      { content: row.feedBackRating || "N/A", styles: { halign: "center" } },
      { content: row.isActive ? "Active" : "InActive", styles: { halign: "center" } }
    ]);

    // Add Total Row
    tableData.push([
      { content: "", styles: { halign: "center" } }, // Empty for S.No
      { content: "Total", styles: { halign: "center", fontStyle: "bold" } }, // "Total" Label
      { content: totalFeedbackRating, styles: { halign: "center", fontStyle: "bold" } }, // Total Value
      { content: "", styles: { halign: "center" } } // Empty for Status
    ]);

    // Generate Table with Centered Text & Headers
    autoTable(doc, {
      head: [["S.No", "Feedback Name", "Feedback Rating", "Status"]],
      body: tableData,
      margin: { top: 20 },
      styles: { halign: "center" },
      headStyles: { halign: "center", fontStyle: "bold",} // Centers header text
    });

    // Save the PDF
    doc.save("TransferStationCategory.pdf");
  };


  return (
    <ExportMenu
      items={[
        { label: "PDF", icon: "fa-solid fa-file-pdf", onClick: downloadPDF },
        { label: "Excel", icon: "fa-solid fa-file-excel", onClick: downloadExcel },
      ]}
    />
  );
};
